import { Component, ChangeDetectionStrategy, ViewEncapsulation, OnInit } from '@angular/core';
import { TemplatePortal } from '@angular/cdk/portal';
import { Subject } from 'rxjs';

@Component({
    // tslint:disable-next-line
    selector: 'eui-message-box-container',
    templateUrl: './eui-message-box-container.component.html',
    styleUrls: ['../styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})

export class EuiMessageBoxContainerComponent implements OnInit {

    public e2eAttr: string = 'eui-message-box';
    public title: string;
    public content: string | TemplatePortal;
    public footer: TemplatePortal;
    public acceptLabel: string;
    public dismissLabel: string;
    public type: ('info' | 'success' | 'warning' | 'danger' | 'question');
    public hasCloseButton: boolean;
    public closeOnClickOutside: boolean;

    public outsideClick = new Subject();
    public open = new Subject();
    public close = new Subject();
    public dismiss = new Subject();
    public accept = new Subject();

    public isContentTemplatePortal = false;
    public isFooterTemplatePortal = false;

    constructor() {}

    ngOnInit(): void {
        if (this.content instanceof TemplatePortal) {
            this.isContentTemplatePortal = true;
        }
        if (this.footer instanceof TemplatePortal) {
            this.isFooterTemplatePortal = true;
        }

        this.open.next();
    }

    public closeMessageBox(): void {
        this.close.next();
    }

    public onDismiss(): void {
        this.dismiss.next();
        this.closeMessageBox();
    }

    public onAccept(): void {
        this.accept.next();
        this.closeMessageBox();
    }
}
